$ti-upload-dialog-content-minheight: 315px;

:host {

    // Base HTML elements applying Polaris styles
    b {
        font-weight: $polaris-font-weight-bold;
    }

    h4 {
        @extend %polaris-font-style-header-4;
    }

    p {
        @extend %polaris-font-style-paragraph-medium;
    }

    table {
        line-height: $polaris-line-height-2;

        th,
        td {
            padding: $polaris-space-4 $polaris-space-3;
            text-align: left;
        }

        tbody td {
            border-bottom: 1px solid $pl-divider-color-secondary;
        }
    }

    ti-drag-and-drop {
        h4 {
            margin: $polaris-space-2 0 0 0;
        }

        p {
            margin: $polaris-space-4 0 0 0;
        }

        ti-file-download {
            margin-top: $polaris-space-1;
        }
    }

    .ti-upload-mylist-dialog-container {
        min-height: 315px; // prevent layout-shift when dialog moves from one screen to another
    }

    .ti-upload-myti-list-forms {
        display: flex;
        gap: $polaris-space-6;
        padding-bottom: $polaris-space-6;
    }

    .ti-upload-myti-list-form-item {
        flex: 1;
    }

    //Icon and text
    .ti-upload-myti-list-filename,
    .ti-upload-myti-list-warning {
        display: flex;
        line-height: $polaris-line-height-2;

        ti-svg-icon {
            margin-right: $polaris-space-2;
        }
        span{
            margin-top:$polaris-space-1;
        }
    }

    .ti-upload-myti-list-filename {
        color: $pl-link-color-primary;

    }

    .ti-upload-myti-list-label {
        display: block;
        padding-top: $polaris-space-3;
        padding-bottom: $polaris-space-2;
        font-size: $polaris-font-size-2;
        font-weight: 500;
    }

    .ti-upload-myti-list-input {
        font-size: $polaris-font-size-root;
    }

    .ti-upload-myti-list-select {
        width: 100%;
        max-width: 300px;
        font-size: $polaris-font-size-root;
    }

    .ti-upload-myti-list-table {
        width: 100%;
        overflow-x: auto;
    }

    .ti-upload-myti-list-worksheet-table > thead {
        background-color: $polaris-background-color-grey;
        border-bottom: 1px solid $pl-divider-color-secondary;
    }

    .ti-upload-myti-list-worksheet-table > thead > tr > th {
        font-weight: $polaris-font-weight-normal;
    }

    .ti-upload-myti-list-worksheet-table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0px;
    }

    .ti-upload-myti-list-table-header1 {
        background-color: $pl-container-background-color-secondary;
        border-top: 1px solid $pl-border-color-primary;
    }

    .ti-upload-myti-list-table-header2 {
        background-color: $pl-container-background-color-primary;
    }

    .ti-upload-myti-list-select-label {
        margin-top: 0;
        margin-bottom: $polaris-space-2;
    }

    .ti-upload-myti-list-col-header {
        padding-right: $polaris-space-2;
    }
}
